module.exports = __webpack_public_path__ + "img/ua.57d4015f.svg";